
import Vue from "vue";

import TaxLookup from "../components/TaxLookup.vue";

export default Vue.extend({
	name: "OwnerOccupancyCreditCalculator",

	props: ["disclaimer", "note"],

	data() {
		return {
			isLoading: true,
		};
	},
	components: {
		TaxLookup,
	},
});
